<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="../../assets/images/pages/not-authorized.png"
        alt="graphic-not-authorized"
        class="mx-auto mb-4"
      />
      <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">Pre Checking.....!</h1>
      <p
        class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse"
      >Authorizing to use this service, please wait.</p>
      <h1 style="color:rgb(216, 83, 59)">{{resmessage}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ftoken: this.$route.params.id,
      authdb: this.$route.params.id2,
      appdb: this.$route.params.id3,
      resmessage: null
    };
  },
  methods: {
    authToken() {
      // this.resmessage = this.$route.params;
      // this.resmessage = this.ftoken + "/" + this.authdb;
      this.$router.replace(
        "/pages/authcheck/" + this.ftoken + "/" + this.authdb + "/" + this.appdb
      );
    }
  },
  created() {
    // this.ctoken = this.deToken();
    this.$store.dispatch("setAuthDB", this.authdb);

    setTimeout(() => {
      localStorage.setItem("authdb", "http://" + this.authdb + "/");

      this.authToken();
    }, 500);
  }
};
</script>
